import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "./AuthContext.js";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAdminAuth();

  if (status === "checking") return null;
  if (status === "unauthenticated") return <Navigate to="/admin/login" replace />;
  return <>{children}</>;
}
